import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getUserPerformanceSummary({ date, userId }) {
    return axiosIns.get(
      '/v2/eod_closing/user_performance_summaries',
      {
        params: snakecaseKeys({ date, userId }),
      },
    )
  },
}
